import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Tag } from 'src/app/data/model/tag-event';
import { TaggableResource } from 'src/app/data/model/tag-resource';

@Component({
  standalone: false,
  selector: 'app-tag-data-dialog',
  templateUrl: './tag-data-dialog.component.html',
  styleUrls: ['./tag-data-dialog.component.scss']
})
export class TagDataDialogComponent implements OnInit {

  public get displayedColumns(): string[] {
    return ['idcli', 'code', 'tagtype', 'group'];
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TagDialogParams
  ) { }

  ngOnInit(): void {
    console.log(this.data)
  }
  

}
export type TagDialogParams = {
  data: Tag[];
  resource: TaggableResource
};